if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.variantIdInput?.addEventListener("change", this.onUpdateParentId.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtonPrimary = this.querySelector('[type="submit"]')
        this.submitButtons = [this.querySelector('[type="submit"]'), ...document.querySelectorAll(`[type="submit"][form="${this.form.getAttribute('id')}"]`)];
        this.submitButtonPrimaryText = this.submitButtonPrimary.querySelector('span')
        this.submitButtonText = this.submitButtons.map(button => (button.querySelector('span')));
        
        if (document.querySelector('cart-drawer')) {
          this.submitButtons.forEach(button => button.setAttribute('aria-haspopup', 'dialog'));
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.removeInputsDuplicates()

        if (this.submitButtonPrimary.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButtons.forEach(button => {
          button.setAttribute('aria-disabled', true);
          button.classList.add('loading');

          button.querySelector('.loading__spinner').classList.remove('hidden');
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

               this.submitButtonPrimary.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButtonPrimary.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButtonPrimary.setAttribute('aria-disabled', true);
              this.submitButtonPrimaryText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {

            this.submitButtons.forEach(button => {
              button.classList.remove('loading');
              button.querySelector('.loading__spinner').classList.add('hidden');
            });

            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButtons.forEach(button => button.removeAttribute('aria-disabled'));

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      removeInputsDuplicates() {
        const observedInputs = new Set();
        const inputs = this.form.querySelectorAll('input[type="hidden"]');

        inputs.forEach(input => {
          if (observedInputs.has(input.name)) {
            input.disabled = true;
          } else {
            observedInputs.add(input.name);
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      onUpdateParentId(event) {
        const { form ,value} = event.target;
        if (form instanceof HTMLFormElement && form.children) {
          [...form.children].forEach(input => {
            if (input instanceof HTMLInputElement && input.name.includes("parent_id") && value) {
              input.value = value
            }
          })
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]') || this.form.querySelector("input.product-variant-id");
      }
    }
  );
}
